var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 2.57196L9.428 5.40062L2.828 12H0V9.17129L6.6 2.57129V2.57196ZM7.54297 1.62939L8.95697 0.214722C9.2173 -0.0455324 9.6393 -0.0455324 9.89964 0.214722L11.7856 2.10072C12.0459 2.36106 12.0459 2.78306 11.7856 3.04339L10.371 4.45739L7.54297 1.62939Z",
    fill: "#405189"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6fe78804a2ff697b52c8b79cc00cfd3b.svg";
export { ForwardRef as ReactComponent };